export default __webpack_public_path__ + "media/src/features/footer/assets/facebook@2x-14ffe5e624217993592d1fecf6476908.png";